export var focus = function (opts, el) {
    if (opts === void 0) { opts = { preventScroll: false }; }
    el === null || el === void 0 ? void 0 : el.focus(opts);
};
